import React from 'react'
import { PurchasingOrgCellContainer } from './styled'

const CompanyCell = (props) => {
  const { title, value, selected, disable, onClick } = props
  return (
    <PurchasingOrgCellContainer className={disable ? 'disable' : selected ? 'selected' : ''} onClick={() => onClick(value)}>
      <input type='checkbox' disabled={disable} checked={selected} value={value} />
      {title}
    </PurchasingOrgCellContainer>
  )
}

CompanyCell.defaultProps = {
  title: '',
  selected: false,
  disable: false
}

export default CompanyCell